import { auto } from '@popperjs/core';
import { makeStyles } from 'tss-react/mui';

const modsDialogStyles = makeStyles<{
  expanded?: boolean;
  isDelete?: boolean;
  isVoid?: boolean;
  isCallingAPI: boolean;
}>()((theme, { expanded, isDelete, isVoid, isCallingAPI }) => ({
  modalContainer: {
    '& .MuiDialog-paper': {
      maxWidth: expanded ? 'none' : isCallingAPI ? '600px' : 'fit-content',
      color: '#333333',
      '& .MuiDialogContent-root': {
        padding: '0',
        overflowY: 'hidden',
        '& .dialogContentRootNoActions': {
          padding: '0px',
        },
      },
    },
  },
  gridContainers: {
    padding: '24px',
    height: isCallingAPI ? '500px' : 'none',
    backgroundColor: '#F5F5F5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  buttonContainers: {
    padding: '24px',
    backgroundColor: '#F5F5F5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  gridRightContainer: {
    overflowY: 'hidden',
    maxHeight: 'calc(100vh - 64px)',
    height: '100%',
    padding: '0px 18px 0px 18px',
    width: expanded ? '60%' : '306px',
  },
  parentGrid: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    overflowY: 'hidden',
    justifyContent: 'space-between'
  },
  alignBtn: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '84px',
    marginTop: '24px',
    justifyContent: 'space-between',
    height: '38px',
  },
  expandedBtn: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '95px',
    marginRight: '-22px',
    marginTop: '255px',
    justifyContent: 'space-evenly',
  },
  cancelBtn: {
    padding: '6px 26px',
    backgroundColor: '#8E9195',
    '&:hover': {
      backgroundColor: '#8E9195',
    },
    color: '#FFF',
    fontSize: '12px',
    marginLeft: isDelete ? '-50px' : '-35px',
    height: '38px',
  },
  submitButton: {
    padding: '6px 28px',
    backgroundColor: '#006FB9',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#006FB9',
    },
    marginRight: isVoid ? '3px' : '0px',
    fontSize: '12px',
    height: '38px',
    '& .MuiInputBase-root.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
  dialogActionButton: {
    paddingRight: 0,
  },
  validationLoader: {
    left: 'calc(50% - 20px)',
    top: '50%',
    position: 'absolute',
  },
  modHeight: {
    maxHeight: expanded ? null : 'calc(100vh - 144px)',
    overflowY: 'scroll',
  },
  banner: {
    paddingBottom: '1px !important',
  },
}));

export default modsDialogStyles;
